export default "__VITE_ASSET__BJuFib$u__"